<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="swiper" id="featureSwiper">
        <div class="swiper-wrapper">
          <div
            v-for="(image, key) in imageList"
            :key="key"
            class="swiper-slide"
          >
            <div class="img-box">
              <img @load="handleLoad(image)" :src="image.url" />
              <loader class="loader" width="960px" height="540px" v-if="image.imageLoading"></loader>
            </div>
          </div>
        </div>
        <div class="swiper-navigation swiper-button__prev"></div>
        <div class="swiper-navigation swiper-button__next"></div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.mjs'
import 'swiper/swiper-bundle.css'

import Loader from '@/components/loader/Index.vue'

import featureMixins from '@/mixins/home/featureMixins.js'

export default {
  name: 'PcHomeFeature',
  mixins: [featureMixins],
  components: {
    Loader,
  },
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('#featureSwiper', {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 1.218274,
          centeredSlides: true,
          effect: "coverflow",
          coverflowEffect: {
            rotate: 0,
            stretch: 728,
            depth: 300,
            modifier: 1,
            slideShadows: false,
          },
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'swiper-pagination__btn',
            bulletActiveClass: 'swiper-pagination--active',
            clickable: true,
            renderBullet: function (index, className) {
              return '<div class="' + className + '"></div>'
            }
          },
          navigation: {
            prevEl: '.swiper-button__prev',
            nextEl: '.swiper-button__next',
          },
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.module {
  height: 992px;

  &__title {
    background-position: center -960px;
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    margin-top: 50px;
    width: 1200px;
    height: 632px;
  }
}

.swiper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1200px;
  height: 100%;
  overflow: visible;

  .swiper-slide {
    position: relative;
    height: 564px;
    opacity: 0;

    ::v-deep .img-box {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 985px;
      height: 564px;
      background: url('~@/assets/img/pc/feature_bg.png') no-repeat;

      .loader {
        position: absolute;
      }
    }
  }

  ::v-deep .swiper-slide-active {
    z-index: 1;
    opacity: 1;
  }

  ::v-deep .swiper-slide-prev,
  ::v-deep .swiper-slide-next {
    opacity: 1;

    .img-box::after {
      content: '';
      position: absolute;
      z-index: 1;
      width: 960px;
      height: 540px;
      background: #000;
      opacity: 0.5;
    }
  }

  ::v-deep img {
    width: 960px;
    height: 540px;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;

    ::v-deep .swiper-pagination__btn {
      display: block;
      margin: 0 10px;
      width: 20px;
      height: 20px;
      background: url('~@/assets/img/common/news_swiper.png') no-repeat;
      background-size: 100%;
      background-position: 0 0;
      cursor: pointer;
    }

    ::v-deep .swiper-pagination--active {
      background-position: 0 -20px;
    }
  }

  .swiper-navigation {
    position: absolute;
    z-index: 1;
    top: 237.5px;
    width: 79px;
    height: 65px;
    background: url('~@/assets/img/pc/navigation_arrow.png') no-repeat;
    cursor: pointer;

    &.swiper-button__prev {
      left: 29px;
    }

    &.swiper-button__next {
      right: 29px;
      transform: rotate(180deg);
    }
  }
}
</style>